const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeEmail = (value = '') => {
  return String(value || '').trim().toLowerCase();
};

export const isValidEmail = (value = '') => {
  return EMAIL_REGEX.test(normalizeEmail(value));
};
